export default __webpack_public_path__ + "static/media/img-0070-uk-full-face.e410e552.png";